import * as yup from 'yup'
import { passwordValidationSchema } from './singleFieldsValidationSchemas'

const validationSchema = yup.object().shape({
  newPassword: passwordValidationSchema,
})
export default validationSchema
